
      var _image;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPersonalArea = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 30,
  height: 30,
  textRendering: "geometricPrecision",
  viewBox: "0 0 30 30"
}, props), _image || (_image = /*#__PURE__*/React.createElement("image", {
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAMAAAAM7l6QAAAAVFBMVEVMaXFwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBxcXFxcXFwcHBxcXFwcHBx01szAAAAG3RSTlMAIIDAMGDwEECg3+CwUL/Qz5Bw759/rz9fj28Z5uG3AAAACXBIWXMAAAPoAAAD6AG1e1JrAAABTUlEQVR42m1TWXbEIAwDEsAEss/SVve/Z80WyLT8JNhPsiRAiLrs12M5gWX5GcWfJR9oa5o/uopx605kR9LBMIfsmpahA7WtMji77Qajb2R2Ba4BDqaoke/3VTtLTdUuTVHXt02bgCn9SCAzH4AfmDWXmV9lmiF1R5goxwa8MhfA8i0wFrZMYn0pDNiF0FizBMBWVUf6amxxozIIqBG1imQKqmhxR6eWqe2hzp7KbK7MDUQ5SA44lErgKb6ixc6Wl4XNF4kJPbRwZxNT22s3IfeiM0dD1B1MnKvgMvTVbsOziDEpcpki7dcjj3bJpktu3DWTTPSYM4/wkU/Ld0MPTNGWKyltfAy36+IxqwxOJ7td4dQINlwAy37XW1uzvKPZ5f7Tti4x1vWPIES3Y3ktnMDHzRWzj363Jb4jdCavq61DycTvUvy3LJHSdHuAv7pvGkMhuwu5AAAAAElFTkSuQmCC",
  width: 30,
  height: 30,
  href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAMAAAAM7l6QAAAAVFBMVEVMaXFwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBxcXFxcXFwcHBxcXFwcHBx01szAAAAG3RSTlMAIIDAMGDwEECg3+CwUL/Qz5Bw759/rz9fj28Z5uG3AAAACXBIWXMAAAPoAAAD6AG1e1JrAAABTUlEQVR42m1TWXbEIAwDEsAEss/SVve/Z80WyLT8JNhPsiRAiLrs12M5gWX5GcWfJR9oa5o/uopx605kR9LBMIfsmpahA7WtMji77Qajb2R2Ba4BDqaoke/3VTtLTdUuTVHXt02bgCn9SCAzH4AfmDWXmV9lmiF1R5goxwa8MhfA8i0wFrZMYn0pDNiF0FizBMBWVUf6amxxozIIqBG1imQKqmhxR6eWqe2hzp7KbK7MDUQ5SA44lErgKb6ixc6Wl4XNF4kJPbRwZxNT22s3IfeiM0dD1B1MnKvgMvTVbsOziDEpcpki7dcjj3bJpktu3DWTTPSYM4/wkU/Ld0MPTNGWKyltfAy36+IxqwxOJ7td4dQINlwAy37XW1uzvKPZ5f7Tti4x1vWPIES3Y3ktnMDHzRWzj363Jb4jdCavq61DycTvUvy3LJHSdHuAv7pvGkMhuwu5AAAAAElFTkSuQmCC",
  preserveAspectRatio: "none"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"30\" height=\"30\" text-rendering=\"geometricPrecision\" viewBox=\"0 0 30 30\"><image xlink:href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAMAAAAM7l6QAAAAVFBMVEVMaXFwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBxcXFxcXFwcHBxcXFwcHBx01szAAAAG3RSTlMAIIDAMGDwEECg3+CwUL/Qz5Bw759/rz9fj28Z5uG3AAAACXBIWXMAAAPoAAAD6AG1e1JrAAABTUlEQVR42m1TWXbEIAwDEsAEss/SVve/Z80WyLT8JNhPsiRAiLrs12M5gWX5GcWfJR9oa5o/uopx605kR9LBMIfsmpahA7WtMji77Qajb2R2Ba4BDqaoke/3VTtLTdUuTVHXt02bgCn9SCAzH4AfmDWXmV9lmiF1R5goxwa8MhfA8i0wFrZMYn0pDNiF0FizBMBWVUf6amxxozIIqBG1imQKqmhxR6eWqe2hzp7KbK7MDUQ5SA44lErgKb6ixc6Wl4XNF4kJPbRwZxNT22s3IfeiM0dD1B1MnKvgMvTVbsOziDEpcpki7dcjj3bJpktu3DWTTPSYM4/wkU/Ld0MPTNGWKyltfAy36+IxqwxOJ7td4dQINlwAy37XW1uzvKPZ5f7Tti4x1vWPIES3Y3ktnMDHzRWzj363Jb4jdCavq61DycTvUvy3LJHSdHuAv7pvGkMhuwu5AAAAAElFTkSuQmCC\" width=\"30\" height=\"30\" href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAMAAAAM7l6QAAAAVFBMVEVMaXFwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBxcXFxcXFwcHBxcXFwcHBx01szAAAAG3RSTlMAIIDAMGDwEECg3+CwUL/Qz5Bw759/rz9fj28Z5uG3AAAACXBIWXMAAAPoAAAD6AG1e1JrAAABTUlEQVR42m1TWXbEIAwDEsAEss/SVve/Z80WyLT8JNhPsiRAiLrs12M5gWX5GcWfJR9oa5o/uopx605kR9LBMIfsmpahA7WtMji77Qajb2R2Ba4BDqaoke/3VTtLTdUuTVHXt02bgCn9SCAzH4AfmDWXmV9lmiF1R5goxwa8MhfA8i0wFrZMYn0pDNiF0FizBMBWVUf6amxxozIIqBG1imQKqmhxR6eWqe2hzp7KbK7MDUQ5SA44lErgKb6ixc6Wl4XNF4kJPbRwZxNT22s3IfeiM0dD1B1MnKvgMvTVbsOziDEpcpki7dcjj3bJpktu3DWTTPSYM4/wkU/Ld0MPTNGWKyltfAy36+IxqwxOJ7td4dQINlwAy37XW1uzvKPZ5f7Tti4x1vWPIES3Y3ktnMDHzRWzj363Jb4jdCavq61DycTvUvy3LJHSdHuAv7pvGkMhuwu5AAAAAElFTkSuQmCC\" preserveAspectRatio=\"none\"/></svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/personal-area.ea07086c449a95d005a72c3d650ccca0.svg"),
        {
          React: SvgPersonalArea,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      